<template>
    <div class="popover_input">
        <div class="text">{{title}}</div>
        <el-input
                type="tel"
                class="input"
                size="mini"
                placeholder="请输入"
                v-model="input"
                @clear="getFocus"
                ref="toFocus"
                clearable>
        </el-input>
        <el-button v-if="countType === 'score'" type="primary" size="mini" icon="el-icon-check" @click="submit" circle></el-button>
        <el-button v-if="countType === 'order'" type="primary" size="mini" icon="el-icon-check" @click="changeIndex" circle></el-button>
        <el-button v-if="countType === 'question'" type="primary" size="mini" icon="el-icon-check" @click="changeQuestionCount" circle></el-button>
        <el-button icon="el-icon-close" size="mini" @click="close" circle></el-button>
    </div>
</template>

<script>
    export default {
        name: "PopoverInput",
        props: {
            title: {
                type: String,
                default: '请输入内容'
            },
            defaultValue: {
                type: String,
                default: ''
            },
            countType: {
                type: String,
                default: ''
            }
        },
        data () {
            return{
                input: ''
            }
        },
        methods: {
            submit () {
                if (!this.input.trim()) {
                    this.$notify.error({
                        title: '提示',
                        message: '请输入分值',
                        offset: 50
                    });
                    return
                }
                if (!Number(this.input.trim())) {
                    this.$notify.error({
                        title: '提示',
                        message: '请输入合法的分值',
                        offset: 50
                    });
                    return
                }
                if (Number(this.input.trim()) < 0.5 || Number(this.input.trim()) > 100) {
                    this.$notify.error({
                        title: '提示',
                        message: '请输入0.5到100的分值',
                        offset: 50
                    });
                    return
                }
                this.$emit('submit', this.input)
            },
            changeIndex () {
                if (!this.input.trim()) {
                    this.$notify.error({
                        title: '提示',
                        message: '请输入序号',
                        offset: 50
                    });
                    return
                }
                if (Number(this.input.trim()) % 1 !== 0 || Number(this.input.trim()) < 1) {
                    this.$notify.error({
                        title: '提示',
                        message: '请输入合法的序号',
                        offset: 50
                    });
                    return
                }
                this.$emit('submit', this.input)
                this.input = ''
            },
            changeQuestionCount () {
                if (!this.input.trim()) {
                    this.$notify.error({
                        title: '提示',
                        message: '请输入题数',
                        offset: 50
                    });
                    return
                }
                if (Number(this.input.trim()) % 1 !== 0 || Number(this.input.trim()) < 1 || Number(this.input.trim()) > 200) {
                    this.$notify.error({
                        title: '提示',
                        message: '请输入1-200之间的整数',
                        offset: 50
                    });
                    return
                }
                this.$emit('submit', this.input)
            },
            close () {
                this.$emit('close')
            },
            getFocus () {
                this.$refs.toFocus.focus()
            }
        }
    }
</script>

<style lang="scss" scoped>
    .popover_input{
        .text{
            border-bottom: 1px solid #ebebeb;
            padding-bottom: 10px;
            margin-bottom: 15px;
        }
        .input{
            width: 120px;
            /deep/ input:focus{
                border-bottom: 1px solid #409eff;
            }
            /deep/ input{
                /*padding-left: 0;*/
                /*border: none;*/
                /*border-radius: 0;*/
                /*border-bottom: 1px solid #DCDFE6;*/
            }
        }
        button{
            margin-left: 5px;
        }
    }
</style>
